<script lang="ts">
import { onMount } from 'svelte';
import SponsorAd from './SponsorAd.svelte';
import { Recipient } from '$lib/recipient';
import { trackOutboundClick, outboundImpression } from '$lib/analytics/outbound';
import { SPONSOR } from '$lib/sponsor';

export let recipient: Recipient = new Recipient();

let sponsorElement: HTMLElement;
let isVisible = false;

function handleSponsorClick() {
  trackOutboundClick(SPONSOR.destination, 'sponsor-box');
}

onMount(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          isVisible = true;
          observer.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.2, rootMargin: '50px' }
  );
  if (sponsorElement) observer.observe(sponsorElement);
  return () => {
    if (sponsorElement) observer.unobserve(sponsorElement);
  };
});
</script>

<a
  href={SPONSOR.url}
  class="spon-anchor"
  target="_blank"
  rel="noopener"
  on:click={handleSponsorClick}
>
  <div class="transition-section">
    <h2>Want an Expert Second Opinion?</h2>
    <div class="text">
      <p>
        You've calculated your Social Security benefit of <b
          >{$recipient.pia().primaryInsuranceAmount().string()}/month</b
        >. Deciding when to claim it is the bigger decision, and the right
        answer depends on your health, your spouse, your other income, and
        your taxes. If you'd like an experienced advisor to review your
        strategy, our sponsor offers a free call with a specialist.
      </p>
    </div>
  </div>

  <div
    bind:this={sponsorElement}
    use:outboundImpression={{ destination: SPONSOR.destination, placement: 'sponsor-box' }}
  >
    <SponsorAd animated {isVisible} />
  </div>
</a>

<style>
  .transition-section {
    margin: 0;
    padding: 0;
  }

  .transition-section h2 {
    /* Match PiaReport h2 styling */
    margin: 0.83em 0;
    font-size: 1.5em;
    font-weight: bold;
    color: inherit;
  }

  .transition-section .text {
    /* Match PiaReport .text styling exactly */
    margin: 0 0.5em;
  }

  /* No hover effect on the anchor itself: it wraps the intro text as well
     as the card, and SponsorAd already highlights the card on hover. */
  .spon-anchor {
    display: block;
    text-decoration: none;
    color: inherit;
    margin: 30px 4px;
  }
</style>
